import { render, staticRenderFns } from "./TabCustomfields.vue?vue&type=template&id=c148c2f4&scoped=true&"
import script from "./TabCustomfields.vue?vue&type=script&lang=js&"
export * from "./TabCustomfields.vue?vue&type=script&lang=js&"
import style0 from "./TabCustomfields.vue?vue&type=style&index=0&id=c148c2f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c148c2f4",
  null
  
)

export default component.exports